import { Device } from '../enums';

export const Devices = [Device.BRACELET, Device.CUFF];
